import * as operations from './operations';
import * as selectors from './selectors';
import * as types from './types';
import * as actions from './actions';

import reducer from './reducer';

export { selectors, operations, types, actions };
export default reducer;



// WEBPACK FOOTER //
// ./src/state/projects/index.js